import { memo, useEffect } from 'react';
import cn from 'classnames';
import { useRouter } from 'next/router';
import { Logger } from 'src/utils';
import { Element, RouterLink } from 'src/components';
import Level from 'src/components/grid/level';
import { trackingPage } from 'src/utils/tracking';
import styles from './styles.module.scss';

interface IProps {
    error?: number;
}

export function Content404({ error }: IProps) {
    const router = useRouter();
    useEffect(() => {
        Logger.error(404, 'Error_404: ', error);
        trackingPage('mobile_404');

        setTimeout(() => {
            router.replace('/');
        }, 100);
    }, []);

    return (
        <Element className={styles['error-page']}>
            <Level className={styles['error__title']}>
                <Level.Side align="left">
                    <RouterLink
                        to="/"
                        title="Trang chủ"
                        className={styles['error__logo']}
                    ></RouterLink>
                </Level.Side>
                <Level.Side align="right">
                    <RouterLink
                        to="/"
                        title="Tải app"
                        className={styles['error__inst']}
                        newTab={true}
                    >
                        Tải ứng dụng Báo Mới
                    </RouterLink>
                    <RouterLink
                        title="Facebook"
                        to="https://www.facebook.com/Baomoi"
                        className={cn(
                            styles['error__btn'],
                            styles['error__btn--fb']
                        )}
                    ></RouterLink>
                    <RouterLink
                        title="Zalo"
                        to="https://zalo.me/"
                        className={cn(
                            styles['error__btn'],
                            styles['error__btn--zalo']
                        )}
                    ></RouterLink>
                </Level.Side>
            </Level>
            <Element className={styles['error__content']}>
                <Element className={styles['page-404']}>
                    Không tìm thấy địa chỉ bạn vừa yêu cầu truy cập.
                    <br />
                    <br />
                    Nếu bạn chắc chắn rằng đã đánh đúng địa chỉ, việc hiện ra
                    trang này là lỗi của chúng tôi, hãy bắt đầu từ
                    <a href="/" className={styles['link']} title="Trang chủ">
                        &nbsp;Trang chủ&nbsp;
                    </a>
                </Element>
            </Element>
        </Element>
    );
}

export default memo(Content404);
